import React from "react";
import TabelaProdap from "features/shared/components/TabelaProdap";
import { tableStyles } from "./tableStyle";
import { withStyles } from "@material-ui/core";
import { formatKgOrZero } from "../utils";
import { Trans, useTranslations } from "adapters/i18n";
import { BannerAlert } from "features/shared/components";

function PlanningIngredientReportTable({
  planningIngredientReport,
  periodTitles,
  classes,
}) {
  const { t } = useTranslations();

  const planningIngredientReportTableViewColumns = () => {
    const periodColumns = periodTitles.map((month, monthIndex) => ({
      id: month,
      titulo: month,
      ordenavel: false,
      pegaValor: (report) => (
        <span>{formatKgOrZero(report.months[monthIndex] || 0)}</span>
      ),
    }));

    return [
      {
        id: "ingredient",
        titulo: t("ingredients:ingredient"),
        ordenavel: false,
        pegaValor: (report) => <span>{report.ingredient.name}</span>,
      },
      ...periodColumns,
      {
        id: "total",
        titulo: t("common:total"),
        ordenavel: false,
        pegaValor: (report) => (
          <span className={classes.cellItemBold}>
            {formatKgOrZero(report.total || 0)}
          </span>
        ),
      },
    ];
  };

  return (
    <div className={classes.container}>
      <h1 className={classes.tableTitle}>
        {t("planning:report.ingredient-title")}
      </h1>
      <div
        className={classes.tableContent}
        data-testid="Plannings-Ingredient-Report-Table"
      >
        <TabelaProdap
          className={classes.tableContainer}
          idCabecalhoTabela={"planningIngredientReportTableHead"}
          colunas={planningIngredientReportTableViewColumns()}
          ativarPaginacao={false}
          linhas={planningIngredientReport}
          tabelaEsquerda={true}
          noPaper
        />
      </div>
      <BannerAlert className={classes.disclaimer} type="plain">
        <Trans i18nKey="planning:report.disclimer-ingredient" />{" "}
      </BannerAlert>
    </div>
  );
}

const style = (theme) => ({
  ...tableStyles(theme),
  disclaimer: {
    marginTop: "12px",
  },
});

export default withStyles(style)(PlanningIngredientReportTable);
